import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CustomMaterialModule } from 'app/custom-material/custom-material.module';
import { GuidedTourModule } from 'ngx-guided-tour';
import { FilterExercisesPipe } from '../pipes/filter-exercises.pipe';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AddCategoryDialogComponent } from './components/exercise-editor/add-category-dialog/add-category-dialog.component';
import { ConfirmationDialogComponent } from './components/exercise-editor/confirmation-dialog/confirmation-dialog.component';
import { ExerciseLibraryEditorComponent } from './components/exercise-editor/exercise-editor.component';
import { RemoveExerciseDialogComponent } from './components/exercise-editor/remove-exercise-dialog/remove-exercise-dialog.component';
import { ExerciseSelectionListComponent } from './components/exercise-selection-list/exercise-selection-list.component';
import { ExerciseProgramRoutingModule } from './exercise-program-routing.module';

@NgModule({
  declarations: [
    DashboardComponent,
    ExerciseSelectionListComponent,
    ExerciseLibraryEditorComponent,
    ConfirmationDialogComponent,
    AddCategoryDialogComponent,
    FilterExercisesPipe,
    RemoveExerciseDialogComponent,
  ],
  imports: [
    CommonModule,
    ExerciseProgramRoutingModule,
    CustomMaterialModule,
    BrowserModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    ScrollingModule,
    GuidedTourModule
  ]
})
export class ExerciseProgramModule { }
